export default {
  init() {
    const panel = document.getElementById('ved-sticky-panel')
    const wrapper = document.getElementById('ved-sticky-wrapper')
    if (!panel) return

    const scrollUp = panel.querySelector('#scroll-up')
    const scrollDown = panel.querySelector('#scroll-down')

    // Sticky keeps the panel flush at top:0 only while it's pinned/fully in
    // view; outside that range its top is either positive (not reached yet)
    // or negative (already scrolled past).
    function isPanelCentered() {
      return Math.abs(panel.getBoundingClientRect().top) < 1
    }

    function centerPanel() {
      window.scrollTo({
        top: window.scrollY + panel.getBoundingClientRect().top,
        behavior: 'smooth',
      })
    }

    function exitAbove() {
      const target = wrapper || panel
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - window.innerHeight,
        behavior: 'smooth',
      })
    }

    function exitBelow() {
      const target = wrapper || panel
      window.scrollTo({
        top: target.getBoundingClientRect().bottom + window.scrollY,
        behavior: 'smooth',
      })
    }

    scrollUp?.addEventListener('click', () => {
      if (isPanelCentered()) exitAbove()
      else centerPanel()
    })
    scrollDown?.addEventListener('click', () => {
      if (isPanelCentered()) exitBelow()
      else centerPanel()
    })
  },
}
